<template lang="pug">

.colorfns
  section.colorfns-intro
    AppTitle.u-mb-sm(:title="$t('mantra')")

    AppLink(to="https://github.com/baianat/color-fns" class="button-link" :title="$t('github')") {{$t('github')}}

    img.colorfns-intro-img(slot-scope="{ parallax }" :style="`transform: rotate(${parallax.rotate}deg)`" src='https://cdn.baianat.com/static/resources/colorfns/1.png', srcset='https://cdn.baianat.com/static/resources/colorfns/1.png 1x, https://cdn.baianat.com/static/resources/colorfns/1@2x.png 2x')

  section.colorfns-install.u-mt-lg
    h2 {{$t('install')}}
    prism(language="js" :code="install")



  section.colorfns-features.u-mt-lg
    .grid.is-ultrawide-8.is-widescreen-9.is-desktop-10.is-center
      .column

        .grid.is-mb
          .column.is-desktop-7.is-tablet-6
            Parallax(:from="{ translateY: 0 }" :to="{ translateY: 100  }")
              .colorfns-features-item(slot-scope="{ parallax }" :style="`transform: translateY(${parallax.translateY}px)`")
                p.u-text-lg {{$t('sec1')}}
          .column.is-desktop-4.is-tablet-6
            Parallax(:from="{ translateY: 0 }" :to="{ translateY: -50  }")
              .colorfns-features-item(slot-scope="{ parallax }" :style="`transform: translateY(${parallax.translateY}px)`")
                  img( src='https://cdn.baianat.com/static/resources/colorfns/3.png', srcset='https://cdn.baianat.com/static/resources/colorfns/3.png 1x, https://cdn.baianat.com/static/resources/colorfns/3@2x.png 2x')

        .grid.u-mt-md.is-mb
          .column.is-desktop-6.is-tablet-6
            Parallax(:from="{ translateY: 0 }" :to="{ translateY: -50  }")
              .colorfns-features-item(slot-scope="{ parallax }" :style="`transform: translateY(${parallax.translateY}px)`")
                img( src='https://cdn.baianat.com/static/resources/colorfns/4.png', srcset='https://cdn.baianat.com/static/resources/colorfns/4.png 1x, https://cdn.baianat.com/static/resources/colorfns/4@2x.png 2x')

          .column.is-desktop-5.is-tablet-6
            Parallax(:from="{ translateY: 0 }" :to="{ translateY: 100  }")
              .colorfns-features-item(slot-scope="{ parallax }" :style="`transform: translateY(${parallax.translateY}px)`")
                h4 {{$t('sec2')}}
                p {{$t('sec2Desc')}}



    section.colorfns-cta.u-mt-lg
      AppTitle(:title="$t('cta')" tag="h2")
      AppLink(to="https://github.com/baianat/color-fns" class="button-link" :title="$t('ctaBtn')") {{$t('ctaBtn')}}



  .u-mb-md

</template>
<style lang="stylus">
$clMain = #19002d
$clGreen = #00e2bd
$clYellow = #f1d500
$clBlue = #5410fd
$clRed = #ff002c

.app.is-colorfns
  overflow: hidden

.colorfns
  &-intro
    padding-top: unitRes(120, 200)
    z-index: 0
    position: relative

    &-img
      position: absolute
      top: -15%
      right: 0
      z-index: -1

  &-cta
    background-color: $clYellow
    padding: unitRes(20, 160)
    color: $clBlack
    background-image: url('https://cdn.baianat.com/static/resources/colorfns/5.jpg')
    background-repeat: no-repeat
    background-position: center center
    background-attachment: fixed
    background-size: cover

  &-install
    color: $clBlack
    margin-left: -12vw
    margin-right: -12vw
    padding: unitRes(20, 160) 8vw
    background-color: $clBlack
    background-image: url('https://cdn.baianat.com/static/resources/colorfns/2.jpg')
    background-repeat: no-repeat
    background-position: center center
    background-attachment: fixed
    background-size: cover

  &-features
    &-item
      +mq($until: 'tablet')
        transform: none !important
</style>

<script>
import { Parallax } from 'leaps';
import Prism from '~/components/Prism';
import { generateSeoMeta } from '~/utils/seo';

export default {
  scrollToTop: true,
  meta: {
    theme: 'is-colorfns is-dark'
  },
  head: generateSeoMeta(
    {
      title: 'pageTitle',
      description: 'pageDesc'
    },
    { i18n: true }
  ),
  components: {
    Prism,
    Parallax
  },
  data: () => ({
    install: `# npm
npm i color-fns

# yarn
yarn add color-fns

Or

<script src="https://unpkg.com/color-fns"><\/script>

## Usage

// ES2015 (ES6)
import { toRgb } from 'color-fns';

console.log(toRgb('#fff'));


// CommonJS
const { toRgb } = require('color-fns');
console.log(toRgb('#fff'));

// UMD (Script Tag)
console.log(ColorFns.toRgb('#fff'));
`
  })
};
</script>

<i18n>
{
  "en": {
    "pageTitle":"Color-fns",
    "pageDesc":"Color-fns is a library we developed to provide a wide range of functions that allow several processing and conversion operations to be done on colors for a more flexible input/output formats of colors.",
    "mantra":"The ultimate | JavaScript color |utility library.",
    "github":"Github",
    "install":"Install",
    "sec1":"Color-fns library provides a wide range of functions that allow several processing and conversion operations to be done on colors for a more flexible input/output formats of colors.",
    "sec2":"Parse, convert andmanipulate",
    "sec2Desc":"Get the color format you need and easily manipulate color input and output data using the several functions color-fns packs.",
    "cta":"Color-fns has | every thing | you need.",
    "ctaBtn":"Get started"
  },
  "ar": {
    "pageTitle":"Color-fns",
    "pageDesc":"Color-fns is a library we developed to provide a wide range of functions that allow several processing and conversion operations to be done on colors for a more flexible input/output formats of colors.",
    "mantra":"مكتبة لا نهائية |من ألوان جافا سكريبت. ",
    "github":"غيت هاب",
    "install":"التثبيت",
    "sec1":"توفر مكتبة Color-fns مجموعة واسعة من المميزات التي تسمح بإجراء العديد من عمليات المعالجة والتحويل للألوان على تنسيقات إدخال / إخراج أكثر مرونة من الألوان.",
    "sec2":"التحليل والتحويل والتغيير",
    "sec2Desc":"احصل على تنسيق اللون الذي تحتاج إليه، وقم بمعالجة بيانات إدخال وإخراج اللون بسهولة باستخدام حزم الوظائف متعددة الألوان.",
    "cta":"توفر  Color-fns كل |ما تحتاج إليه. ",
    "ctaBtn":"ابدأ الآن"

  }
}
</i18n>
